import { useLeadsDashboard } from "@/hooks/useLeadsDashboard";
import { DashboardHeader, PillGroup } from "@/components/admin/DashboardChrome";
import { StatsGrid } from "@/components/admin/StatsGrid";
import { LeadsTable } from "@/components/admin/LeadsTable";
import { LEAD_STATUSES } from "@/data/leads";

const RANGES = [7, 30, 90].map((d) => ({ id: d, label: `${d} days` }));
const FILTERS = [{ id: "all", label: "All" }, ...LEAD_STATUSES];

export default function AdminDashboard() {
    const d = useLeadsDashboard();

    return (
        <div data-testid="admin-dashboard" className="min-h-screen bg-night text-ivory">
            <DashboardHeader loading={d.loading} onRefresh={d.load} />
            <main className="mx-auto max-w-7xl px-6 py-12 sm:px-12 lg:px-20">
                <div className="flex flex-wrap items-end justify-between gap-6">
                    <div>
                        <p className="text-xs uppercase tracking-[0.25em] text-gold">Overview</p>
                        <h1 className="mt-3 font-serif text-3xl font-light sm:text-4xl">How the website is working for you</h1>
                    </div>
                    <PillGroup options={RANGES} value={d.days} onChange={d.setDays} testPrefix="range" />
                </div>
                <div className="mt-8">
                    <StatsGrid summary={d.summary} days={d.days} />
                </div>

                <div className="mt-20 flex flex-wrap items-end justify-between gap-6">
                    <div>
                        <p className="text-xs uppercase tracking-[0.25em] text-gold">Enquiries</p>
                        <h2 data-testid="leads-count-heading" className="mt-3 font-serif text-3xl font-light [font-feature-settings:'lnum']">
                            {d.leads.length} {d.filter === "all" ? "total" : d.filter}
                        </h2>
                    </div>
                    <PillGroup options={FILTERS} value={d.filter} onChange={d.setFilter} testPrefix="leads-filter" />
                </div>
                <div className="mt-8">
                    <LeadsTable leads={d.leads} onStatus={d.updateStatus} onDelete={d.remove} />
                </div>
            </main>
        </div>
    );
}
